import { render, staticRenderFns } from "./TelegramSettings.vue?vue&type=template&id=e3e352a0"
import script from "./TelegramSettings.vue?vue&type=script&lang=js"
export * from "./TelegramSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports